import logo from '../img/logo.svg';

function Logo() {
  return (
    <>
      <img src={logo} alt="rendered puzzle"></img>
    </>
  )
}

export default Logo;